<!--上班时长、加班时长选择弹窗-->
<template>
  <div>
    <el-dialog
      title="选择时长"
      width="800px"
      :visible.sync="visiable"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="()=>{handleBeforeClose();$emit('cancel')}"
    >
      <div class="content">
        <div style="position: relative;left:-15px">请选择时长</div>
        <el-radio-group v-model="val" style="position: relative;top:-3px">
          <el-radio border :label="(index+1)*step" v-for="(item,index) in sum" :key="index">{{ (index+1)*step }}小时</el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="flex_jc_center footer">
        <el-button @click="handleBeforeClose();$emit('cancel')">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" style="margin-left:20px">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "workTimeSelect",
  props: {
    visiable: {
      type: Boolean,
    },
    value: {
      type: [String,Number]
    },
    sum:{
      type:Number,
      default:48
    },
    step:{
      type:Number,
      default:0.5
    }
  },
  data() {
    return {
      list: [],
      val: ""
    }
  },
  watch: {
    visiable() {
      this.val = isNaN(this.value)?0.5:this.value
      this.val = this.val || 0.5
    }
  },
  methods: {
    handleBeforeClose() {
      this.$emit('update:visiable', false)
    },
    // 确认时长
    handleSubmit() {
      this.$emit('update:value', this.val)
      this.$emit('save')
      this.handleBeforeClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px 35px 30px;
  position: relative;

  .el-radio-group {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .el-radio {
      width: 105px;
      margin: 20px 0 0;
      height: 34px;
      padding: 9px 20px 0 10px
    }
  }
}
.el-radio.is-bordered+.el-radio.is-bordered{
  margin-left: 0 !important;
}

/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__footer{
  padding-bottom: 40px;
}
.footer {
  .el-button{
    padding: 9px 12px;
  }
}
</style>
